var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('div',[_c('v-alert',{attrs:{"transition":"scale-transition","type":"info"}},[_vm._v(" Add Milady app to home screen? "),_c('v-btn',{staticClass:"mr-2",on:{"click":_vm.installPWA}},[_vm._v("Install!")]),_c('v-btn',{on:{"click":_vm.dismissPrompt}},[_vm._v("No, thanks")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }